/*
 * Bylōn pre-launch plant-match quiz.
 * Vanilla-JS port of the Claude Design "Bylon Landing v2" quiz component.
 * - Opens a full-screen overlay from any <a href="#quiz">.
 * - Smooth-scrolls any <a href="#collectors"> to the newsletter block.
 * - Submits the quiz email (+ all answers as properties) to Klaviyo.
 * - Progressively enhances the landing newsletter form to submit to Klaviyo too.
 *
 * Klaviyo config comes from window.BylonKlaviyo (emitted by sections/FM-quiz.liquid):
 *   { publicKey: '', listId: '', customSource: '' }
 * When unset, forms still show their success state and the payload is logged +
 * cached to localStorage (mirrors the original design behaviour).
 */
(function () {
  'use strict';

  var root = document.getElementById('bylon-quiz-root');
  var IMG = (window.BylonQuizConfig && window.BylonQuizConfig.images) || {};

  // --- Option imagery (store CDN files from the design; overridable via config.images) ---
  var IMAGES = Object.assign({
    'q1-opt1': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/20260402_Bylon_0307_FullRes.jpg?v=1785522717',
    'q1-opt2': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/20260402_Bylon_0631.jpg?v=1775572971',
    'q1-opt3': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/20260402_RNS_Bylon_0378_HighRes_76c1e761-acd2-4f38-854d-560886384e2b.jpg?v=1785522898',
    'q1-opt4': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_01_427a86db-7de1-49a6-96fa-f3ac35b99831.jpg?v=1785522418',
    'q2-opt1': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_12.jpg?v=1785522418',
    'q2-opt2': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_03.jpg?v=1780407482',
    'q2-opt3': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_09_bcbbb02e-8358-40da-9ee9-593e7c8fd2e0.jpg?v=1785522418',
    'q2-opt4': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_31.jpg?v=1780405706',
    'q2-opt5': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_10_ba8a9378-3191-44ce-9004-20343f72cc25.jpg?v=1780407423',
    'q2-opt6': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_21.jpg?v=1780407606',
    'q2-opt7': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_18_b2a5eb22-87cd-4efd-8a27-e6a34a739cc7.jpg?v=1782255033',
    'q2-opt8': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_24.jpg?v=1780407561',
    // Art for the Q3 education panel, one per care-experience answer.
    'q3-art1': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_09_bcbbb02e-8358-40da-9ee9-593e7c8fd2e0.jpg?v=1785522418',
    'q3-art2': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_15_7e48ce63-6c80-46dd-a1aa-0faa4cc6b0aa.jpg?v=1785522418',
    'q3-art3': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_31.jpg?v=1780405706',
    'q3-art4': 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/Bylon_May2026_03.jpg?v=1780407482'
  }, IMG);

  var QUESTIONS = [
    {
      numeral: 'I', title: 'To start, what brings you here?',
      sub: 'Getting a plant is good for no reason at all. But if you do have reason, it helps to narrow our recommendation.',
      options: ['Make my home lovelier', 'Send a gift for someone', 'I love plants', 'Want a relaxing hobby']
    },
    {
      numeral: 'II', title: 'Where would it live?',
      sub: 'Different locations have different lighting, heating, and air flow. While all Bylon plants are easy, some species are even more forgiving than others.',
      options: ['By a sunny window', 'A sitting desk', 'A shelf or mantel', 'In a moody space', 'The living room', 'By the front door', 'In the kitchen', 'Beside my bed']
    },
    {
      numeral: 'III', title: 'What is your plant care experience?', noImages: true,
      sub: 'The care ritual a Bylon plant is the same for every plant, regardless of your experience level.',
      options: ['None at all', 'I have lost a few', 'I have some experience', 'A practiced green thumb'],
      eduOptions: [
        { q: 'Soil-free plants don’t require any experience.', b: 'Bylon plants can be kept by a complete beginner. Each plant comes with a detailed care guide, and each plant has the same ritual: flush, fill, feed twice a month.' },
        { q: 'No more plant care stress.', b: 'Bylon’s soil-free plants live longer while also being easier to care for. All plants have water roots suspended above the water, allowing the roots to breathe. No overwatering, underwatering, anxiety, or frustration.' },
        { q: 'Beautiful and rewarding to tend.', b: 'Bylon plants make a lovely and non-fussy addition to your existing plant collection. Care is less than a minute: flush, fill, feed twice a month.' },
        { q: 'A new medium for a practiced hand.', b: 'Bylon plants are grown semi-hydroponically, which gives you what soil never could: roots in full view, precise control of water and nutrients, and an easy way to propagate further.' }
      ]
    },
    {
      // The only multi-select question. It feeds nothing in the recommendation —
      // its answers exist to segment the Collector's list in Klaviyo.
      // Order is shuffled per visit: with ten options and a cap of three, the
      // tiles that happen to sit first would otherwise collect the picks and
      // shape the segments more than preference does.
      numeral: 'IV', title: 'What about Bylon speaks to you?', noImages: true,
      multi: true, maxPicks: 3, shuffle: true,
      sub: 'Choose up to three.',
      options: ['Considered design', 'Roots on display', 'No soil, no mess', 'Lives longer', 'No bugs, no mould', 'Something new', 'Simple care routine', 'Good as a gift', 'Crafted vessels', 'Less maintenance']
    }
  ];

  // Retired: "Lastly, what would make your home feel more yours?" was Question
  // V. The quiz ran long, so it is no longer asked and no longer sent to
  // Klaviyo. The result screen's closing line — which used to come from this
  // answer — now comes from the light in Question II instead, see STATEMENTS. The
  // quotes are retired with it: the result screen no longer carries one at
  // all. All kept here so the copy is not lost.
  var RETIRED_DESIRE_QUESTION = {
    numeral: 'V', title: 'Lastly, what would make your home feel more yours?', noImages: true,
    sub: 'Plants uniquely add all these elements to a room. But if you had to choose one, what would it be?',
    options: ['More life', 'More calm', 'More beauty', 'More ritual', 'More memories'],
    subs: ['Family, friends, pets, and plants', 'Soft light, quiet corners, less clutter', 'Objects and greenery worth a long look', 'Small routines that mark the day', 'Mementos, photos, keepsakes, and heirlooms'],
    resultLines: [
      'These three are the most of varieties. They will grow and thrive before your eyes. More life, on the easiest possible terms.',
      'Greenery always in our peripheral vision is biologically calming. These three ask almost nothing and softens any room they are in.',
      'These three sculptural plants with interesting textures and hues of green are sure to catch anyone’s eye. More beauty to live with every day.',
      'Flush, fill, feed twice a month. These three are rewarding plants that you will enjoy tending to.',
      'Plants keep time the way keepsakes do. These three grow along with you, sometimes into the next generation.'
    ],
    quotes: [
      { text: 'Where flowers bloom, so does hope.', attr: 'Lady Bird Johnson' },
      { text: 'Nowhere can man find a quieter or more untroubled retreat than in his own soul.', attr: 'Marcus Aurelius, Meditations' },
      { text: 'Have nothing in your houses that you do not know to be useful, or believe to be beautiful.', attr: 'William Morris' },
      { text: 'Ichi-go ichi-e — every meeting, once in a lifetime.', attr: 'The guiding proverb of the Japanese tea ceremony' },
      { text: 'The heart, like the mind, has a memory. And in it are kept the most precious keepsakes.', attr: 'Henry Wadsworth Longfellow' }
    ]
  };

  // Light per Q2 location: 1 low, 2 medium, 3 bright
  var LIGHT_BY_LOCATION = [3, 2, 2, 1, 2, 1, 2, 1];

  // Plants: light needed (1-3), care experience suited (1-4).
  //   w    three descriptor words, set on their own line on the card
  //   d    the rest of the description
  //   f    one-liner fact revealed when the card is flipped
  //   img  store CDN image
  var CDN = 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/';
  var PLANT_DB = [
    {
      n: 'Pothos', light: 1, care: 1,
      t: 'The Vaquero',
      w: 'Persistent. Versatile. Effortless.',
      d: 'Its refusal to quit, this pothos is the ultimate green companion for any home. It thrives in almost any light, making it perfect for those who want maximum impact with minimal fuss.',
      f: 'In the wild it climbs tree trunks, and its leaves grow larger the higher it gets.',
      img: CDN + 'pothos-in-terrace-vessel-5705636.jpg?v=1785930428'
    },
    {
      n: 'Lucky bamboo', light: 1, care: 1,
      t: 'The Guardian',
      w: 'Hopeful. Steady. Upright.',
      d: 'The Lucky Bamboo is a tall, jointed plant long kept in the home as a quiet wish for good fortune. Made for housewarmings and milestones, and for a desk or windowsill where you’ll pass it often.',
      f: 'It is not a bamboo at all — it is a Dracaena, and it will grow happily in nothing but water.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/lucky-bamboo-in-terrace-vessel-8529003.jpg?v=1785930374'
    },
    {
      n: 'Snake plant', light: 1, care: 1,
      t: 'The Protector',
      w: 'Tall. Upright. Enduring.',
      d: 'The Snake Plant’s proud, vertical leaves hold their line in a low-light corner and clean the air as they go. For the plant owner who’d rather not think about plant care, as it’s forgiving of irregular schedules and missed care sessions.',
      f: 'It is one of the few plants that releases oxygen at night rather than during the day.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/snake-plant-in-terrace-vessel-8541842.jpg?v=1785930428'
    },
    {
      n: 'ZZ plant', light: 1, care: 1,
      t: 'The Champion',
      w: 'Glossy. Forgiving. Unbothered.',
      d: 'The ZZ Plant’s waxy fronds fan out in clean vertical lines as it grows bigger. It’s a beginner’s ally that seasoned collectors keep around for its crisp and unique silhouette.',
      f: 'Its underground rhizomes store water, which is how it goes a month without asking for anything.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/zz-plant-in-terrace-vessel-8833869.jpg?v=1785930375'
    },
    {
      n: 'Heartleaf philodendron', light: 1, care: 1,
      t: 'The Bohemian',
      w: 'Free-spirited. Trailing. Lush.',
      d: 'The Heartleaf Philodendron sends out heart-shaped leaves on vines that drape from a high shelf or climb a wall. For anyone who likes a little untamed movement in their greenery — and a plant that asks very little in return.',
      f: 'Its aerial roots are made for climbing — give it a pole and it will start reaching upward.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/heartleaf-philodendron-in-terrace-vessel-4870093.jpg?v=1785930375'
    },
    {
      n: 'Peperomia', light: 2, care: 1,
      t: 'The Jester',
      w: 'Curious. Easygoing. Endearing.',
      d: 'With its plump, rippled leaves and compact form, the Peperomia brings a touch of whimsy to shelves, desks, and windowsills. It’s perfect for those who love low-fuss plants that can be tucked anywhere.',
      f: 'There are more than a thousand Peperomia species, and almost none of them look alike.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/peperomia-in-terrace-vessel-4406589.jpg?v=1785930371'
    },
    {
      n: 'Spider plant', light: 2, care: 1,
      t: 'The Vintage',
      w: 'Retro. Prolific. Amenable.',
      d: 'A quick grower with a retro charm, the Spider Plant spills gently over the rim of its vessel as it sends out new shoots. It’s an air-purifying, easygoing companion for shelves and high perches.',
      f: 'A mature plant can send out dozens of pups, each one a whole new plant on a stem.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/spider-plant-in-terrace-vessel-8367982.jpg?v=1785930373'
    },
    {
      n: 'Silver aglaonema', light: 1, care: 2,
      t: 'The Guard',
      w: 'Serene. Dependable. Graceful.',
      d: 'The Silver Aglaonema’s silver-green leaves and gentle variegation help to soften a room. At home on a bedside table or in a quiet corner, it’s content in lower light than most.',
      f: 'It has been kept as a good-luck plant across Southeast Asia for well over a thousand years.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/silver-aglaonema-in-terrace-vessel-7455255.jpg?v=1785930376'
    },
    {
      n: 'Red aglaonema', light: 2, care: 2,
      t: 'The Muse',
      w: 'Colorful. Uncomplicated. Adaptable.',
      d: 'The Red Aglaonema’s bold strokes of red and green warm up a room. Easy in most light and unfazed by the occasional missed care ritual, it suits almost any spot you give it.',
      f: 'Its red deepens with brighter indirect light, so the colour is a record of where it has lived.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/red-aglaonema-in-terrace-vessel-4149646.jpg?v=1785930378'
    },
    {
      n: 'UFO plant', light: 2, care: 2,
      t: 'The Dauphin',
      w: 'Playful. Charming. Compact.',
      d: 'Also called the Chinese Money Plant, the UFO Plant’s round, coin-like leaves bring character to a shelf or a styled vignette. A small, undemanding piece for anyone working with a tight footprint.',
      f: 'It spread around the world through cuttings passed hand to hand, long before any nursery sold it.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/pilea-small-espresso-ivory.jpg?v=1762767940'
    },
    {
      n: 'Money tree', light: 2, care: 2,
      t: 'The Magnate',
      w: 'Lucky. Tropical. Steadfast.',
      d: 'The Money Tree has long been read and kept as a symbol of prosperity, with the potential for steady growth over decades. For that reason, it can be a thoughtful marker for a new job or a fresh start.',
      f: 'The braided trunk is done by hand while the stems are young and still pliable.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/money-tree-in-terrace-vessel-5266370.jpg?v=1785930376'
    },
    {
      n: 'Rubber tree', light: 2, care: 3,
      t: 'The Vanguard',
      w: 'Glossy. Refined. Tolerant.',
      d: 'The Rubber Tree’s thick, deep-green leaves and steady upright growth suit anyone who likes a more polished, rather than entirely organic, look. A reliable companion that asks only for a well-lit spot and keeping to the care ritual.',
      f: 'It was tapped commercially for latex before the Pará rubber tree took over the trade.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/rubber-tree-in-terrace-vessel-3912246.jpg?v=1785930374'
    },
    {
      n: 'Watermelon peperomia', light: 2, care: 3,
      t: 'The Chanteuse',
      w: 'Petite. Eye-catching. Friendly.',
      d: 'A compact powerhouse, this plant’s vivid, watermelon-striped leaves add bold color to any space, making it perfect for those seeking a small plant with big impact.',
      f: 'Its leaves are thick enough to store their own water, which is why it forgives a late watering.',
      img: 'https://cdn.shopify.com/s/files/1/0694/3771/8811/files/watermelon-peperomia-in-terrace-vessel-8668017.jpg?v=1785930375'
    },
    {
      n: 'Monstera deliciosa', light: 2, care: 3,
      t: 'The Prima Donna',
      w: 'Bold. Dramatic. Sculptural.',
      d: 'The Monstera Deliciosa’s iconic split leaves unfurl into a genuine statement. Happiest in bright, indirect light, it anchors a living room or fills an empty corner with ease.',
      f: 'The holes in its leaves let wind and light pass through to the leaves below.',
      img: CDN + '40.jpg?v=1788543950'
    },
    {
      n: 'Variegated rubber tree', light: 3, care: 3,
      t: 'The Architect',
      w: 'Confident. Expressive. Poised.',
      d: 'The Variegated Rubber Tree carries painterly swirls of cream, green, and blush that draw the eye without trying. Its tall, upright form suits a statement corner or a creative space that can hold a strong presence.',
      f: 'No two leaves carry the same pattern — the variegation is drawn fresh on every one.',
      img: CDN + 'variegated-rubber-tree-in-terrace-vessel-9071256.jpg?v=1785930374'
    }
  ];

  // One sentence per light bucket (1-3). Care experience no longer changes the
  // line: every plant here takes the same care, so the sentence says so
  // instead of implying four levels of difficulty.
  var STATEMENTS = [
    'These three do well in a low-light room and are easy to care for.',
    'These three do well in the indirect light and are easy to care for.',
    'These three do well bathed in bright light and are easy to care for.'
  ];

  var LAST_STEP = QUESTIONS.length - 1;
  // "Question X of Y": the total is read off the last question's own numeral,
  // so adding or removing a question can never leave the two out of step.
  var TOTAL_NUMERAL = QUESTIONS[LAST_STEP].numeral;
  // A multi-select question has no Next to press once the cap is reached, so it
  // advances itself — after a beat, so the third tick is actually seen.
  var MULTI_ADVANCE_MS = 260;
  var JOINED_MSG = 'Your place on the list is secured. We will stay in touch until the Spring.';

  // --- Result-screen pricing (COMMENTED OUT) --------------------------------
  // The price test is switched off: the result screen no longer offers sizes
  // or prices, the reserve button is no longer gated on one, and no price,
  // size or cohort property is sent to Klaviyo. Everything below is kept
  // verbatim so the test can be switched back on; the other halves of it are
  // commented out in place at priceGrid, syncReserveState,
  // clearPriceHighlight, pickPrice, the 'pick-price' click branch, and the
  // price properties in joinFromQuiz. Picking a plant is untouched.
//   // --- Result-screen pricing ------------------------------------------------
//   // The result screen is the price test. Nine prices go on it — three sizes for
//   // each of the three matches — all of them derived from a single random draw,
//   // so different visitors are asked to reserve the same plant at different
//   // money and what they pick says something about what they would pay. This
//   // replaced the vessel question, whose three fixed prices were shown to
//   // everybody alike.
//   //
//   // Each size has its own band, and the bands are not the same width, so a
//   // size is not a fixed amount over the small the way it once was. The draw
//   // picks a level instead — one rung on a shared ladder — and every size reads
//   // its own price off that level, at the same position within its own band.
//   // Level 0 is the floor of all three bands, the top level their ceiling.
//   var SIZE_BANDS = [
//     { key: 'small', label: 'Small', min: 125, max: 165 },
//     { key: 'medium', label: 'Medium', min: 150, max: 195 },
//     { key: 'tall', label: 'Tall', min: 200, max: 250 }
//   ];
//   // Prices land on multiples of five: a $163 vessel reads as a mistake.
//   var PRICE_STEP = 5;
//   // Rungs on the draw. Nine puts the small band on an exact $5 grid
//   // (125, 130 … 165); the wider bands step faster and so skip a value here and
//   // there, which is why each price is rounded back onto the grid below.
//   var PRICE_LEVELS = 9;
//   // How many cards the result screen deals, and so how many ladders are drawn.
//   var LADDER_COUNT = 3;
// 
//   // The first card's level is drawn; the second card sits at least one level
//   // above it, and the third at least one above the second. Plants therefore
//   // always climb in price across the row, which is the shape being tested: the
//   // same three matches, offered at three different levels, to see where the
//   // reserving stops. The top of the draw is held back one level per card still
//   // to come, so the third card always has somewhere to go and no draw is
//   // retried.
//   function rollPrices() {
//     var ladders = [];
//     var level = -1;
//     for (var i = 0; i < LADDER_COUNT; i++) {
//       var lo = i === 0 ? 0 : level + 1;
//       var hi = PRICE_LEVELS - 1 - (LADDER_COUNT - 1 - i);
//       level = lo + Math.floor(Math.random() * (hi - lo + 1));
//       ladders.push(rungsFor(level));
//     }
//     return ladders;
//   }
//   // Held apart from the loop so the closure cannot capture the running level.
//   function rungsFor(level) {
//     var t = level / (PRICE_LEVELS - 1);
//     return SIZE_BANDS.map(function (b) {
//       var span = b.max - b.min;
//       return {
//         key: b.key,
//         label: b.label,
//         price: b.min + PRICE_STEP * Math.round(span * t / PRICE_STEP)
//       };
//     });
//   }
// 
//   var priceLadders = null;
//   // Drawn once per page load and kept for the rest of it — deliberately not
//   // re-rolled when the quiz is reopened, the way the option shuffle is. If it
//   // were, anyone could close and reopen until they liked the number, and the
//   // answers would say more about patience than about price.
//   function ladders() {
//     if (!priceLadders) priceLadders = rollPrices();
//     return priceLadders;
//   }
//   // Prices belong to a position on the screen, not to a plant: the first card
//   // is always the cheapest, whichever plant the answers put there.
//   function ladderAt(pi) {
//     return ladders()[pi] || null;
//   }
//   // Reserving is gated on this: a signup with no price says nothing about what
//   // anyone would pay, which is the whole point of the screen.
//   function priceChosen() {
//     return state.pickedIndex != null && state.pickedSize != null;
//   }
//   function pickedRung() {
//     if (state.pickedIndex == null || state.pickedSize == null) return null;
//     var l = ladderAt(state.pickedIndex);
//     return l ? l[state.pickedSize] : null;
//   }
//   function selectedPrice() {
//     var r = pickedRung();
//     return r ? r.price : null;
//   }
//   function sizeLabel() {
//     var r = pickedRung();
//     return r ? r.label : null;
//   }
//   // All nine prices on the screen, card by card. Sent whether or not one was
//   // picked: a profile that chose none still has to record the offer it turned
//   // down.
//   function pricesOffered() {
//     return ladders().reduce(function (all, l) {
//       return all.concat(l.map(function (rung) { return rung.price; }));
//     }, []);
//   }

  // --- Opening loader -------------------------------------------------------
  // The quiz opens on an unfurling-leaf screen while the Q1/Q2 option images
  // are fetched, then drops into Question I on its own. The loader is held for
  // LOADER_MIN_MS so it reads as a beat rather than a flicker, and abandoned
  // after LOADER_MAX_MS so a slow connection never traps anyone on it. The Q3
  // art and the result-screen plants load quietly afterwards.
  var LOADER_MIN_MS = 1200;
  var LOADER_MAX_MS = 3000;
  // The word is static; the three dots arrive one at a time. Kept as separate
  // spans rather than animating `content`, which Firefox does not support.
  var LOADER_WORD = 'Growing';
  var LOADER_MSG = 'Growing...';
  // Cut-out leaf for the loading/cover screens. Handed over by FM-quiz.liquid as a
  // theme asset URL; if the section did not emit one there is simply no leaf.
  var LOADER_IMG = (window.BylonQuizConfig && window.BylonQuizConfig.loaderImage) || '';

  // Cover screen: sits between the loader and Question I, so the quiz starts
  // on the visitor's click rather than dropping them straight into a question.
  var COVER_TITLE = 'Which plant is right for you?';
  var COVER_SUB = 'Take the questions to see which plant best suits your space. You have the option to reserve the Collector’s edition of the plant at the end. 1 minute long.';
  var COVER_CTA = 'Begin';
  var preloaded = false;

  // The store originals are full-resolution; asking the Shopify CDN for the
  // width actually painted is the difference between a few hundred KB and
  // several MB per screen. Preload and render MUST agree on these URLs — a
  // mismatch of one character means the preloaded copy is never reused.
  var OPT_W = 700;   // option tile, at most half a 860px panel on a 2x screen
  var ART_W = 900;   // Q3 education art
  var PLANT_W = 700; // result cards
  function sized(url, w) {
    if (!url || url.indexOf('cdn.shopify.com') === -1 || url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function optUrl(key) { return sized(IMAGES[key], OPT_W); }
  function artUrl(key) { return sized(IMAGES[key], ART_W); }
  function plantUrl(url) { return sized(url, PLANT_W); }

  function gateUrls() {
    return Object.keys(IMAGES)
      .filter(function (k) { return k.indexOf('q1-') === 0 || k.indexOf('q2-') === 0; })
      .map(optUrl);
  }
  function restUrls() {
    return Object.keys(IMAGES)
      .filter(function (k) { return k.indexOf('q3-') === 0; })
      .map(artUrl)
      .concat(PLANT_DB.map(function (p) { return plantUrl(p.img); }));
  }
  // Resolves only once the bitmap is decoded, not merely downloaded — a
  // downloaded-but-undecoded image still paints a frame late, which is the
  // pop-in the loader exists to prevent.
  function preload(urls) {
    return Promise.all(urls.filter(Boolean).map(function (url) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          if (img.decode) img.decode().then(resolve, resolve); else resolve();
        };
        img.onerror = function () { resolve(); };
        img.src = url;
      });
    }));
  }

  // ---------------------------------------------------------------------------
  // State
  // ---------------------------------------------------------------------------
  var state = {
    open: false, step: 0, phase: 'question', selected: null,
    answers: [], joined: false,
    // Name of the plant the visitor picks on the result screen, sent to
    // Klaviyo as 'Quiz: Chosen Plant'. Null until they choose one.
    pickedPlant: null,
    // Which result cards are showing their fact side, keyed by plant name.
    flipped: {},
    // Shuffled display order for questions declared with shuffle: true, keyed
    // by question index. Re-drawn on each open of the quiz, not each render.
    optionOrder: {},
    // Furthest question reached, 0-indexed. Rides along to Klaviyo so a
    // completed profile still shows how far they got before the email.
    maxStep: 0,
//     // The size picked on the result screen, as an index into SIZES, and which
//     // of the three cards it was picked on — needed as well as pickedPlant
//     // because every card carries its own prices, so the size alone does not
//     // name a price. Null until a size is picked, which is optional, unlike the
//     // plant.
//     pickedSize: null,
//     pickedIndex: null
  };

  // True once every one of QUESTIONS is behind the visitor — i.e. on the
  // result screen.
  function isPostQuestion() {
    return state.phase === 'result';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function topPlants(light, exp) {
    return PLANT_DB
      .map(function (p, i) {
        return { p: p, i: i, score: Math.abs(p.light - light) * 2 + (p.care > exp ? (p.care - exp) * 1.5 : (exp - p.care) * 0.5) };
      })
      .sort(function (a, b) {
        return a.score - b.score || Math.abs(a.p.light - light) - Math.abs(b.p.light - light) || a.i - b.i;
      })
      .slice(0, 3).map(function (x) { return x.p; });
  }

  function derived() {
    var light = LIGHT_BY_LOCATION[state.answers[1] != null ? state.answers[1] : 0];
    if (light == null) light = 2;
    var exp = (state.answers[2] != null ? state.answers[2] : 0) + 1;
    var isGift = (state.answers[0] != null ? state.answers[0] : 0) === 1;
    return { light: light, exp: exp, isGift: isGift };
  }

  // ---------------------------------------------------------------------------
  // Rendering
  // ---------------------------------------------------------------------------
  function progressSvg() {
    // One bud per question, spaced along the stem path below; each y is that
    // path's height at its x, so the buds sit on the stem rather than near it.
    // Sampled at t = 0.1 / 0.37 / 0.63 / 0.9 along that curve, which spreads
    // the four evenly and still carries the last one out to the stem's tip.
    var pts = [[15, 34.6], [48, 33.0], [84, 30.5], [128, 26.7]];
    var rot = [-6, 14, -10, 8];
    // Leaves alternate above and below the branch the way they do on a real
    // stem. The odd ones are mirrored on Y — and drawn a little shorter, both
    // because a hanging leaf reads smaller and because it keeps them inside
    // the 48px band the bar allots.
    var DOWN_SCALE = 0.78;
    var dots = pts.map(function (pt, qi) {
      var down = qi % 2 === 1;
      var flip = down ? ' scale(' + DOWN_SCALE + ' ' + -DOWN_SCALE + ')' : '';
      var opened = qi < state.step || (qi === state.step && state.phase !== 'question') || isPostQuestion();
      var current = qi === state.step && state.phase === 'question';
      var op = opened ? 1 : (current ? 0.75 : 0.3);
      var sc = opened ? 1 : (current ? 0.6 : 0.35);
      var budStyle = 'opacity:' + op + ';transform:scale(' + sc + ');transform-origin:50% 100%;transform-box:fill-box;transition:transform .4s ease,opacity .4s ease';
      var swayStyle = 'animation:bylon-sway ' + (3.8 + qi * 0.6) + 's ease-in-out ' + (qi * 0.7) + 's infinite;transform-origin:25% 100%;transform-box:fill-box';
      return '<g transform="translate(' + pt[0] + ' ' + pt[1] + ') rotate(' + rot[qi] + ')' + flip + '"><g style="' + budStyle + '">' +
        '<path d="M0 -2 L0.6 2" stroke="#77683F" stroke-width="1.6" stroke-linecap="round"></path>' +
        '<g style="' + swayStyle + '">' +
        '<path d="M0 -2 C-3 -9 -2 -15 3 -19 C8 -14 8 -7 3 -2 C2 -1 1 -1 0 -2 Z" fill="url(#wc-bud)"></path>' +
        '<path d="M3 -19 C5 -15 6 -11 5 -7" stroke="#6E7F42" stroke-width="1.1" stroke-linecap="round" fill="none" opacity="0.7"></path>' +
        '<path d="M0 -2 C-1 -6 -1 -10 1 -13" stroke="#8A7248" stroke-width="1" stroke-linecap="round" fill="none" opacity="0.5"></path>' +
        '</g></g></g>';
    }).join('');
    return '<svg class="bqz-progress" width="150" height="48" viewBox="0 0 150 48" fill="none" aria-label="Progress">' +
      '<defs>' +
      '<filter id="wc-rough" x="-20%" y="-20%" width="140%" height="140%"><feTurbulence type="fractalNoise" baseFrequency="0.14" numOctaves="2" result="n"></feTurbulence><feDisplacementMap in="SourceGraphic" in2="n" scale="3.5"></feDisplacementMap></filter>' +
      '<linearGradient id="wc-stem" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="#6B5638"></stop><stop offset="0.55" stop-color="#8A7248"></stop><stop offset="1" stop-color="#77683F"></stop></linearGradient>' +
      '<linearGradient id="wc-bud" x1="0" y1="1" x2="0.4" y2="0"><stop offset="0" stop-color="#8B9A55" stop-opacity="0.85"></stop><stop offset="0.6" stop-color="#A9BA6E" stop-opacity="0.9"></stop><stop offset="1" stop-color="#C4D08D" stop-opacity="0.85"></stop></linearGradient>' +
      '</defs>' +
      '<g filter="url(#wc-rough)">' +
      '<path d="M4 35 C40 34 84 31 146 25 " stroke="url(#wc-stem)" stroke-width="2.4" stroke-linecap="round" fill="none" opacity="0.9"></path>' +
      '<path d="M74 31 C80 34 84 38 86 42" stroke="#77683F" stroke-width="1.6" stroke-linecap="round" fill="none" opacity="0.7"></path>' +
      dots + '</g></svg>';
  }

  // A single photographed leaf, cut out of its background (assets/quiz-loader-leaf.png),
  // unfurling on a loop. The blade opens from its own base (scaleX from a sliver to
  // full) inside a swaying wrapper that matches the progress tracker's sway, one hand
  // throughout. CSS owns the timing, see .bqz-loader in bylon-landing.css.
  function loaderLeaf() {
    if (!LOADER_IMG) return '';
    return '<span class="bqz-loader__leaf">' +
      '<span class="bqz-loader__sway">' +
      '<img class="bqz-loader__blade" src="' + esc(LOADER_IMG) + '" alt="" width="60" height="129" decoding="async">' +
      '</span></span>';
  }

  function loadingScreen() {
    return '<div class="bqz-loader" role="status" aria-live="polite">' +
      loaderLeaf() +
      '<p class="bqz-loader__msg" aria-label="' + esc(LOADER_MSG) + '">' + esc(LOADER_WORD) +
        '<span class="bqz-loader__dot" aria-hidden="true">.</span>' +
        '<span class="bqz-loader__dot" aria-hidden="true">.</span>' +
        '<span class="bqz-loader__dot" aria-hidden="true">.</span>' +
      '</p>' +
      '</div>';
  }

  function coverScreen() {
    return '<div class="bqz-cover">' +
      loaderLeaf() +
      '<h2 class="bqz-cover__title">' + esc(COVER_TITLE) + '</h2>' +
      '<p class="bqz-cover__sub">' + esc(COVER_SUB) + '</p>' +
      '<button type="button" class="bqz-cover__cta" data-action="begin">' + esc(COVER_CTA) + '</button>' +
      '</div>';
  }

  // Display order for a question's options. Everything but the shuffled
  // question renders in the order it is declared. A shuffled question draws its
  // order once per visit and keeps it: re-drawing on every render would move
  // the tiles under the visitor's finger between picks.
  //
  // Only the display order changes. Answers are stored, scored and sent as the
  // declared index, so nothing downstream has to know about this.
  function orderFor(qi) {
    var q = QUESTIONS[qi];
    var order = [];
    var i;
    for (i = 0; i < q.options.length; i++) order.push(i);
    if (!q.shuffle) return order;
    if (!state.optionOrder[qi]) {
      for (i = order.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = order[i]; order[i] = order[j]; order[j] = t;
      }
      state.optionOrder[qi] = order;
    }
    return state.optionOrder[qi];
  }

  // Picks on a multi-select question live in state.answers as an array of
  // option indexes; state.selected only ever holds a single-select answer.
  function picksFor(qi) {
    var a = state.answers[qi];
    return Array.isArray(a) ? a : [];
  }

  function optionCard(q, qi, label, oi) {
    var selected = q.multi ? picksFor(qi).indexOf(oi) !== -1 : state.selected === oi;
    // At the cap the unpicked tiles are dimmed rather than removed, so the
    // limit is visible before it is hit rather than as a dead click.
    var capped = q.multi && !selected && picksFor(qi).length >= q.maxPicks;
    var cls = 'bqz-opt' + (selected ? ' is-selected' : '') + (capped ? ' is-capped' : '') +
      (q.noImages ? ' bqz-opt--text' : ' bqz-opt--image');
    if (!q.noImages) {
      var key = 'q' + (qi + 1) + '-opt' + (oi + 1);
      var src = optUrl(key);
      // Not lazy: every one of these was preloaded and decoded before the
      // question was allowed to render, so deferring them only re-introduces
      // the pop-in for the tiles below the fold.
      var media = src
        ? '<span class="bqz-opt__media"><img src="' + esc(src) + '" alt="" decoding="sync"></span>'
        : '<span class="bqz-opt__media bqz-opt__media--empty"></span>';
      return '<button type="button" class="' + cls + '" data-action="select" data-opt="' + oi + '">' +
        media + '<span class="bqz-opt__label">' + esc(label) + '</span></button>';
    }
    var sub = (q.subs && q.subs[oi]) ? '<span class="bqz-opt__sub">' + esc(q.subs[oi]) + '</span>' : '';
    // Multi-select tiles are toggles, so they carry their state for screen
    // readers; single-select tiles are one-shot and do not.
    var pressed = q.multi ? ' aria-pressed="' + (selected ? 'true' : 'false') + '"' : '';
    return '<button type="button" class="' + cls + '"' + pressed + ' data-action="select" data-opt="' + oi + '">' +
      '<span class="bqz-opt__label">' + esc(label) + '</span>' + sub + '</button>';
  }

  function questionScreen() {
    var qi = state.step;
    var q = QUESTIONS[qi];
    var optionsHtml = orderFor(qi).map(function (oi) { return optionCard(q, qi, q.options[oi], oi); }).join('');

    var body;
    if (q.noImages) {
      body = '<div class="bqz-options bqz-options--wrap">' + optionsHtml + '</div>';
    } else {
      var cols = q.options.length <= 4 ? 2 : 4;
      // Question I uses portrait 3:4 option images; the rest stay square.
      var mediaRatio = qi === 0 ? ' bqz-options--media-3x4' : '';
      // --bqz-cols drives the tablet-and-up grid: at most four across, so
      // Q1 (4 options) is one row and Q2 (8 options) is two rows of four.
      // Below that breakpoint the cols2/cols4 classes still apply.
      var wideCols = Math.min(q.options.length, 4);
      body = '<div class="bqz-options bqz-options--grid bqz-options--cols' + cols + mediaRatio +
        '" style="--bqz-cols:' + wideCols + '">' + optionsHtml + '</div>';
    }

    // Single-select records the answer and advances on the click, so it needs
    // no Next. Multi-select shows one as soon as there is something to
    // continue with — a third pick advances on its own.
    var next = '';
    if (q.multi && picksFor(qi).length) {
      next = '<button type="button" class="bqz-confirm" data-action="advance">Next</button>';
    }
    return '<div class="bqz-question' + (q.multi ? ' bqz-question--multi' : '') + '">' +
      '<div class="bqz-eyebrow">Question ' + q.numeral + ' of ' + TOTAL_NUMERAL + '</div>' +
      '<h2 class="bqz-title">' + esc(q.title) + '</h2>' +
      (q.sub ? '<p class="bqz-sub">' + esc(q.sub) + '</p>' : '') +
      body +
      next +
      '</div>';
  }

  // Q3 only: the education panel now gets a screen of its own, shown after the
  // answer is picked, so the art has the full height to itself.
  function eduScreen() {
    var q = QUESTIONS[state.step];
    var a = state.answers[state.step];
    var e = q.eduOptions[a];
    var artSrc = artUrl('q3-art' + (a + 1));
    var art = artSrc
      ? '<div class="bqz-mid__art"><img src="' + esc(artSrc) + '" alt="" decoding="sync"></div>'
      : '<div class="bqz-mid__art"></div>';

    return '<div class="bqz-question bqz-question--edu">' +
      '<div class="bqz-mid bqz-mid--edu">' +
        art +
        '<h2 class="bqz-mid__quote">“' + esc(e.q) + '”</h2>' +
        '<p class="bqz-mid__body">' + esc(e.b) + '</p>' +
      '</div>' +
      '<button type="button" class="bqz-confirm" data-action="advance">Next</button>' +
      '</div>';
  }

//   // One button per size, carrying this card's price for it. Each card has
//   // prices of its own — see rollPrices — so the card's position is stamped on
//   // every button alongside the plant it belongs to.
//   function priceGrid(p, pi) {
//     var cells = (ladderAt(pi) || []).map(function (rung, si) {
//       var on = state.pickedIndex === pi && state.pickedSize === si;
//       return '<button type="button" class="bqz-price' + (on ? ' is-selected' : '') + '"' +
//         ' aria-pressed="' + (on ? 'true' : 'false') + '"' +
//         ' aria-label="' + esc(rung.label + ' ' + p.n + ', $' + rung.price) + '"' +
//         ' data-action="pick-price" data-plant="' + esc(p.n) + '"' +
//         ' data-index="' + pi + '" data-size="' + si + '">' +
//         '<span class="bqz-price__size">' + esc(rung.label) + '</span>' +
//         '<span class="bqz-price__amount">$' + rung.price + '</span>' +
//         '</button>';
//     }).join('');
//     return '<div class="bqz-plant__prices" role="group" aria-label="' +
//       esc('Choose a size for the ' + p.n) + '">' + cells + '</div>';
//   }

  function resultScreen() {
    var d = derived();
    var keepQ = d.isGift ? 'Which one would you get?' : 'Which one would you get?';
    var plants = topPlants(d.light, d.exp);

    var cards = plants.map(function (p, pi) {
      var picked = state.pickedPlant === p.n;
      var flipped = !!state.flipped[p.n];
      var faded = state.pickedPlant !== null && !picked;
      // The prices ride on the front face, under the name. The photograph and
      // its two lines are their own button — the one that turns the card over
      // — rather than the whole card being one: a card that was itself a button
      // could not hold the price buttons, since no control may sit inside
      // another. The back face gets the same treatment so it can be turned back.
      var pressed = ' aria-pressed="' + (picked ? 'true' : 'false') + '"';
      var flipAttrs = ' data-action="choose-plant" data-plant="' + esc(p.n) + '"' + pressed;
      return '<div class="bqz-plant' + (picked ? ' is-selected' : '') + (flipped ? ' is-flipped' : '') +
        (faded ? ' is-faded' : '') + '" data-plant="' + esc(p.n) + '">' +
        '<div class="bqz-plant__inner">' +
          '<div class="bqz-plant__face bqz-plant__face--front">' +
            '<button type="button" class="bqz-plant__flip"' + flipAttrs +
              ' aria-label="' + esc(p.n) + ' — ' + esc(p.t) + ', tap to choose and read more">' +
              '<span class="bqz-plant__media"><img src="' + esc(plantUrl(p.img)) + '" alt="" decoding="sync"></span>' +
              '<span class="bqz-plant__name">' + esc(p.n) + '</span>' +
              '<span class="bqz-plant__title">' + esc(p.t) + '</span>' +
            '</button>' +
//             priceGrid(p, pi) +
          '</div>' +
          '<div class="bqz-plant__face bqz-plant__face--back">' +
            '<button type="button" class="bqz-plant__flip bqz-plant__flip--back"' + flipAttrs +
              ' aria-label="' + esc(p.n) + ', tap to turn the card back">' +
              '<span class="bqz-plant__words">' + esc(p.w) + '</span>' +
              '<span class="bqz-plant__desc">' + esc(p.d) + '</span>' +
            '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');

    // No quotation on this screen any more — just the summary, chosen by the
    // light of the room they named in Question II. Experience still narrows
    // which three plants are shown; it no longer changes the sentence.
    var statement = STATEMENTS[d.light - 1];
    var quoteBlock = '<div class="bqz-result__quote">' +
      '<p class="bqz-result__quote-line">' + esc(statement + ' ' + keepQ) + '</p>' +
      '</div>';

    var tail = state.joined
      ? '<p class="bqz-joined">' + esc(JOINED_MSG) + '</p>'
      : '<div class="bqz-form">' +
          '<input id="bqz-email" type="email" placeholder="Your email" autocomplete="email"' +
            ' inputmode="email" spellcheck="false" aria-describedby="bqz-email-note">' +
          // Price test commented out: the reserve button is no longer held
          // back on a size being chosen, so it ships enabled.
          // '<button type="button" class="bqz-submit' + (priceChosen() ? '' : ' is-waiting') +
          //   '" aria-disabled="' + (priceChosen() ? 'false' : 'true') +
          '<button type="button" class="bqz-submit"' +
            ' data-action="join-quiz">Reserve for Next Spring</button>' +
        '</div>' +
        // Validation feedback and the typo suggestion share one live region, so
        // a screen reader is told once rather than twice.
        '<p class="bqz-form__note bqz-form__note--feedback" id="bqz-email-note" role="status" hidden></p>' +
        // Was: 'Choose a size above, then share your email to join …' — the
        // size is gone with the price test.
        '<p class="bqz-form__note">Share your email to join the Collector’s list, where you can reserve your plant and receive a special Collector’s edition at our arrival next Spring.</p>';

    return '<div class="bqz-result">' +
      '<h2 class="bqz-result__title">Your top 3 matches</h2>' +
      quoteBlock +
      '<div class="bqz-plants">' + cards + '</div>' +
      tail + '</div>';
  }

  function render() {
    if (!root) return;
    if (!state.open) { root.innerHTML = ''; root.hidden = true; return; }
    root.hidden = false;
    // Loader and cover both come before Question I, so neither shows the
    // progress tracker or a back button.
    var loading = state.phase === 'loading' || state.phase === 'cover';
    var content = state.phase === 'loading' ? loadingScreen()
      : state.phase === 'cover' ? coverScreen()
      : state.phase === 'result' ? resultScreen()
      : state.phase === 'edu' ? eduScreen()
      : questionScreen();
    // The loader keeps only the close button: there is nothing to go back to,
    // and the progress tracker has no honest state before Question I.
    var bar = loading
      ? '<div class="bqz-bar">' +
          '<div class="bqz-bar__spacer"></div>' +
          '<button type="button" class="bqz-close" data-action="close" aria-label="Close">×</button>' +
        '</div>'
      : '<div class="bqz-bar">' +
          '<button type="button" class="bqz-back" data-action="back" aria-label="Back">‹</button>' +
          '<div class="bqz-bar__spacer"></div>' +
          progressSvg() +
          '<button type="button" class="bqz-close" data-action="close" aria-label="Close">×</button>' +
        '</div>';
    root.innerHTML =
      '<div class="bylon-quiz" role="dialog" aria-modal="true" aria-label="Plant match quiz">' +
        '<div class="bylon-quiz__panel">' +
          bar +
          content +
        '</div>' +
      '</div>';
  }

  // ---------------------------------------------------------------------------
  // Behaviour
  // ---------------------------------------------------------------------------
  function openQuiz() {
    state.open = true; state.step = 0;
    state.selected = state.answers[0] != null ? state.answers[0] : null;
    // A fresh shuffle per open. Answers are held by declared index, so an
    // earlier session's picks survive the reshuffle intact.
    state.optionOrder = {};
    document.documentElement.style.overflow = 'hidden';
    // Second and later opens skip the loader — the images are already in
    // cache — but still open on the cover.
    state.phase = preloaded ? 'cover' : 'loading';
    render();
    if (state.phase === 'loading') runLoader();
  }
  function beginQuiz() {
    state.phase = 'question';
    state.step = 0;
    state.selected = state.answers[0] != null ? state.answers[0] : null;
    render();
  }
  // Resolves on whichever comes first: images-ready-and-minimum-elapsed, or the
  // hard ceiling. Either way the gate opens exactly once.
  function runLoader() {
    var opened = false;
    function openFirstQuestion() {
      if (opened) return;
      opened = true;
      preloaded = true;
      preload(restUrls());
      // Closed while the loader was up — leave the state alone, the next open
      // will land on Question I directly.
      if (!state.open || state.phase !== 'loading') return;
      state.phase = 'cover';
      render();
    }
    Promise.all([
      preload(gateUrls()),
      new Promise(function (resolve) { setTimeout(resolve, LOADER_MIN_MS); })
    ]).then(openFirstQuestion);
    setTimeout(openFirstQuestion, LOADER_MAX_MS);
  }
  function closeQuiz() {
    state.open = false;
    document.documentElement.style.overflow = '';
    render();
  }
  // Picking an option records the answer and moves on straight away — there is
  // no Next button on a question screen. Q3 detours via its education panel,
  // which is the only screen that still has one.
  function selectOpt(oi) {
    if (QUESTIONS[state.step].multi) return togglePick(oi);
    state.selected = oi;
    state.answers[state.step] = oi;
    if (state.step > state.maxStep) state.maxStep = state.step;
    cacheProgress();
    if (QUESTIONS[state.step].eduOptions) {
      state.phase = 'edu';
      render();
      return;
    }
    advance();
  }
  // Multi-select: a tap adds a pick, a second tap on the same tile takes it
  // back, and taps past the cap do nothing (those tiles are dimmed). Reaching
  // the cap is itself an answer, so it advances without a Next.
  function togglePick(oi) {
    var qi = state.step;
    var q = QUESTIONS[qi];
    var picks = picksFor(qi).slice();
    var at = picks.indexOf(oi);
    if (at !== -1) picks.splice(at, 1);
    else if (picks.length >= q.maxPicks) return;
    else picks.push(oi);
    // Empty is stored as null, not [], so an untouched question and one that
    // was cleared back out read the same everywhere downstream.
    state.answers[qi] = picks.length ? picks : null;
    if (qi > state.maxStep) state.maxStep = qi;
    cacheProgress();
    render();
    if (picks.length < q.maxPicks) return;
    setTimeout(function () {
      // Only advance if they are still sitting on this question — the beat is
      // long enough for a back, a close, or a deselect to land first.
      if (!state.open || state.phase !== 'question' || state.step !== qi) return;
      if (picksFor(qi).length < q.maxPicks) return;
      advance();
    }, MULTI_ADVANCE_MS);
  }

  // Marks one plant as the selection: its card comes forward, the other two
  // recede. Shared by the card and by its price buttons, and applied to the
  // live nodes rather than through render() — a re-render rebuilds the cards,
  // which would cut the flip transition short and replay their deal-in
  // animation. State keeps it all correct across any later re-render.
  function markPlant(name) {
    Array.prototype.forEach.call(root.querySelectorAll('.bqz-plant'), function (card) {
      var other = card.getAttribute('data-plant');
      var mine = other === name;
      card.classList.toggle('is-selected', mine);
      card.classList.toggle('is-faded', !mine);
      Array.prototype.forEach.call(card.querySelectorAll('.bqz-plant__flip'), function (b) {
        b.setAttribute('aria-pressed', mine ? 'true' : 'false');
      });
      // Only one card shows its detail side at a time — the others turn back.
      if (!mine && state.flipped[other]) {
        state.flipped[other] = false;
        card.classList.remove('is-flipped');
      }
    });
  }

//   // The reserve button is held back until a size is chosen. aria-disabled
//   // rather than the disabled property: a disabled button cannot be clicked, and
//   // so could never explain itself — this one stays clickable and answers.
//   function syncReserveState() {
//     if (!root) return;
//     var btn = root.querySelector('[data-action="join-quiz"]');
//     if (!btn || btn.disabled) return;
//     var ready = priceChosen();
//     btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
//     btn.classList.toggle('is-waiting', !ready);
//   }
// 
//   function clearPriceHighlight() {
//     Array.prototype.forEach.call(root.querySelectorAll('.bqz-price.is-selected'), function (b) {
//       b.classList.remove('is-selected');
//       b.setAttribute('aria-pressed', 'false');
//     });
//   }

  // One click does both jobs: it turns the card to its detail side and makes
  // that plant the selection. `el` is the flip button, so the card it belongs
  // to has to be found from it.
  function choosePlant(name, el) {
//     // A different plant is a different question about price, and its card has
//     // prices of its own, so a size picked against the old one is cleared
//     // rather than carried across to it.
//     if (state.pickedPlant !== name) {
//       state.pickedSize = null;
//       state.pickedIndex = null;
//       clearPriceHighlight();
//     }
    state.pickedPlant = name;
    state.flipped[name] = !state.flipped[name];
    var card = el ? el.closest('.bqz-plant') : null;
    if (card) card.classList.toggle('is-flipped', state.flipped[name]);
    markPlant(name);
//     syncReserveState();
    cacheProgress();
  }

//   // Picking a size picks its plant too — there is no way to name a price for
//   // a plant you have not chosen. The card is left however it was facing: a
//   // price click is not a request to read the description.
//   function pickPrice(name, pi, si, el) {
//     var l = ladderAt(pi);
//     if (!l || !l[si]) return;
//     state.pickedPlant = name;
//     state.pickedIndex = pi;
//     state.pickedSize = si;
//     clearPriceHighlight();
//     if (el) {
//       el.classList.add('is-selected');
//       el.setAttribute('aria-pressed', 'true');
//     }
//     markPlant(name);
//     syncReserveState();
//     cacheProgress();
//   }
  // Per-answer progress is written locally only — nothing goes to Klaviyo
  // until an email is submitted, so no anonymous profiles are created.
  function cacheProgress() {
    try {
      localStorage.setItem('bylon-quiz-progress', JSON.stringify({
        answers: state.answers,
//         price: selectedPrice(),
        maxStep: state.maxStep,
        completed: isPostQuestion(),
        updatedAt: new Date().toISOString()
      }));
    } catch (e) { /* ignore */ }
  }

  // state.selected only carries single-select answers; a multi-select question
  // reads its picks straight out of state.answers, so it is parked at null.
  function selectionFor(qi) {
    if (QUESTIONS[qi].multi) return null;
    return state.answers[qi] != null ? state.answers[qi] : null;
  }

  function advance() {
    if (state.step < LAST_STEP) {
      state.step += 1; state.phase = 'question';
      state.selected = selectionFor(state.step);
    } else {
      state.phase = 'result';
    }
    render();
  }

  function back() {
    if (state.phase === 'result') {
      state.phase = 'question'; state.step = LAST_STEP;
      state.selected = selectionFor(LAST_STEP);
    } else if (state.phase === 'edu') {
      // Back out of the education panel to the question that opened it.
      state.phase = 'question';
      state.selected = selectionFor(state.step);
    } else if (state.step > 0) {
      state.step -= 1;
      state.phase = QUESTIONS[state.step].eduOptions && state.answers[state.step] != null ? 'edu' : 'question';
      state.selected = selectionFor(state.step);
    } else {
      // Back out of Question I to the cover rather than closing outright.
      state.phase = 'cover';
    }
    render();
  }

  // ---------------------------------------------------------------------------
  // Email validation
  // ---------------------------------------------------------------------------
  // Klaviyo has no browser-callable validation endpoint, so this runs in two
  // stages. Locally: shape, then a typo check against the domains people
  // actually mistype — which is where nearly all lost signups come from, not
  // from malformed addresses. Then Klaviyo itself is the authority on submit:
  // its rejection is surfaced instead of the success state, which used to be
  // shown no matter what the API answered.
  var COMMON_DOMAINS = [
    'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.ca', 'yahoo.co.uk',
    'hotmail.com', 'hotmail.ca', 'hotmail.co.uk', 'outlook.com', 'live.com',
    'msn.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'proton.me',
    'protonmail.com', 'gmx.com', 'shaw.ca', 'rogers.com', 'sympatico.ca',
    'bell.net', 'telus.net', 'comcast.net', 'verizon.net', 'sbcglobal.net'
  ];
  // Endings that are always a slip: nobody owns a .con or a .cmo address.
  // Real TLDs stay off this list even when they look like typos — .co, .cm and
  // .ne are all live country domains, and correcting them would break the
  // address of anyone who actually uses one.
  var TLD_FIXES = {
    'com': ['con', 'cim', 'cmo', 'ocm', 'vom', 'xom', 'comm', 'clm', 'copm', 'cpm'],
    'net': ['nte', 'ent'],
    'org': ['ogr', 'rog']
  };
  // Deliberately permissive on the local part — plus-addressing, dots and
  // apostrophes are all legal, and rejecting a real address is worse than
  // letting Klaviyo turn away a fake one.
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  function emailShapeError(email) {
    if (!email) return 'Enter an email address.';
    if (email.indexOf('@') === -1) return 'That address is missing the @.';
    if (!EMAIL_RE.test(email)) return 'That address does not look complete.';
    if (email.indexOf('..') !== -1) return 'That address does not look complete.';
    var domain = email.split('@').pop();
    if (domain.split('.').pop().length < 2) return 'That address does not look complete.';
    if (email.length > 254) return 'That address is too long.';
    return null;
  }

  // Levenshtein, capped: anything further than two edits away is a different
  // domain rather than a typo of this one.
  function editDistance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 99;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(
          prev[j] + 1,
          cur[j - 1] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
        );
      }
      for (j = 0; j <= b.length; j++) prev[j] = cur[j];
    }
    return prev[b.length];
  }

  // Returns a corrected address, or null when the domain looks intentional.
  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return null;
    var local = email.slice(0, at);
    var domain = email.slice(at + 1).toLowerCase();
    if (!domain) return null;
    if (COMMON_DOMAINS.indexOf(domain) !== -1) return null;

    // A mistyped ending on an otherwise correct domain: gmail.con.
    var parts = domain.split('.');
    var tld = parts[parts.length - 1];
    var fixed = null;
    Object.keys(TLD_FIXES).forEach(function (good) {
      if (TLD_FIXES[good].indexOf(tld) !== -1) fixed = good;
    });
    if (fixed) {
      parts[parts.length - 1] = fixed;
      return local + '@' + parts.join('.');
    }

    // Otherwise the whole domain against the list: gmial.com, hotnail.com.
    var best = null, bestScore = 3;
    COMMON_DOMAINS.forEach(function (candidate) {
      var score = editDistance(domain, candidate);
      if (score < bestScore) { bestScore = score; best = candidate; }
    });
    return best ? local + '@' + best : null;
  }

  // --- Inline feedback ------------------------------------------------------
  // Written straight to the live nodes rather than through render(), which
  // would rebuild the input and throw away what has been typed into it.
  function emailNodes() {
    return {
      input: document.getElementById('bqz-email'),
      note: document.getElementById('bqz-email-note')
    };
  }
  function clearEmailNote() {
    var n = emailNodes();
    if (n.input) n.input.removeAttribute('aria-invalid');
    if (!n.note) return;
    n.note.hidden = true;
    n.note.innerHTML = '';
    n.note.className = 'bqz-form__note bqz-form__note--feedback';
  }
  function showEmailError(msg) {
    var n = emailNodes();
    if (n.input) n.input.setAttribute('aria-invalid', 'true');
    showFormError(msg);
  }
  // The same live region, for something the email field is not to blame for —
  // so it does not get marked invalid.
  function showFormError(msg) {
    var n = emailNodes();
    if (!n.note) return;
    n.note.hidden = false;
    n.note.className = 'bqz-form__note bqz-form__note--feedback is-error';
    n.note.textContent = msg;
  }
  function showEmailSuggestion(fixed) {
    var n = emailNodes();
    if (!n.note) return;
    n.note.hidden = false;
    n.note.className = 'bqz-form__note bqz-form__note--feedback is-suggestion';
    n.note.innerHTML = 'Did you mean <button type="button" class="bqz-email-fix" ' +
      'data-action="fix-email" data-email="' + esc(fixed) + '">' + esc(fixed) + '</button>?';
  }
  function applyEmailSuggestion(fixed) {
    var n = emailNodes();
    if (n.input) { n.input.value = fixed; n.input.focus(); }
    clearEmailNote();
  }
  // Runs while typing (debounced) and again on leaving the field. `live` keeps
  // it quiet until the address is plausibly finished, so an error does not
  // appear on the second keystroke of every address.
  function checkEmailField(live) {
    var n = emailNodes();
    if (!n.input) return true;
    var email = n.input.value.trim();
    if (live && (!email || email.indexOf('@') === -1 || email.split('@').pop().indexOf('.') === -1)) {
      clearEmailNote();
      return false;
    }
    var err = emailShapeError(email);
    if (err) { showEmailError(err); return false; }
    var fixed = suggestEmail(email);
    if (fixed) { showEmailSuggestion(fixed); return true; }
    clearEmailNote();
    return true;
  }
  var emailTimer = null;
  function scheduleEmailCheck() {
    clearTimeout(emailTimer);
    emailTimer = setTimeout(function () { checkEmailField(true); }, 450);
  }

  function joinFromQuiz() {
    var input = document.getElementById('bqz-email');
    var email = input ? input.value.trim() : '';
//     // The size comes first, ahead of the address: it is the thing above the
//     // form and the one more easily walked past, and a reservation with no
//     // price on it is not worth taking. The email field is right under the
//     // hand, so its own error can wait its turn.
//     if (!priceChosen()) {
//       showFormError('Choose a size above before reserving.');
//       var first = root && root.querySelector('.bqz-price');
//       if (first) {
//         if (first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
//         first.focus();
//       }
//       return;
//     }
    var shapeError = emailShapeError(email);
    if (shapeError) {
      showEmailError(shapeError);
      if (input) input.focus();
      return;
    }
    // A suggestion is advice, not a block — the address is well-formed, so a
    // second press goes through with whatever they typed.
    var d = derived();
    // Property names are the readable labels that appear in the Klaviyo
    // segment builder. Values are the visitor's own answer text, verbatim, so
    // a segment condition reads the same as the option they clicked.
    var props = compact(Object.assign({
      'Quiz: Intent': labelOf(0),
      'Quiz: Location': labelOf(1),
      'Quiz: Experience': labelOf(2),
      // Multi-select, so this one is a list — same shape as Top Matches. In
      // Klaviyo it segments with "contains", not "equals".
      'Quiz: Appeal': labelsOf(3),
      // 'Quiz: Desire' is gone with the retired Question V — see
      // RETIRED_DESIRE_QUESTION. Existing profiles keep the property; no new
      // one is ever set.
      // 'Quiz: Vessel Price' is gone with the retired vessel question — the
      // price signal comes off the result screen now. Existing profiles keep
      // the property; no new one is ever set.
      //
//       // The size the visitor picked and what it was priced at for them. Never
//       // absent: joinFromQuiz will not send without a size, so every profile
//       // carries a price.
//       'Quiz: Selected Size': sizeLabel(),
//       'Quiz: Selected Price': selectedPrice(),
//       // All nine prices this visitor was shown, card by card, so the one they
//       // took can be read against the eight they passed over.
//       'Quiz: Prices Offered': pricesOffered(),
//       // Which of the three cards the pick was made on, 1-3, so the cheapest,
//       // middle and dearest card can be told apart without matching prices back.
//       'Quiz: Selected Card': state.pickedIndex + 1,
//       // The draw itself as a cohort label — the small price of the first card,
//       // which every other price on the screen is derived from, so everyone
//       // shown the same nine segments together. Was a hardcoded 'medium' back
//       // when the vessel question showed one fixed set of prices to everybody.
//       price_testing_cohort: 'S' + ladders()[0][0].price,
      'Quiz: Light Level': d.light,
      'Quiz: For A Gift': d.isGift,
      'Quiz: Top Matches': topPlants(d.light, d.exp).map(function (p) { return p.n; }),
      'Quiz: Chosen Plant': state.pickedPlant,
      // Drop-off signal: how far they got, and whether every question was
      // answered. Only ever sent for people who reach the email step.
      'Quiz: Last Question Reached': state.maxStep + 1,
      'Quiz: Completed': state.answers.filter(function (a) { return a != null; }).length === QUESTIONS.length
    }, contextProperties()));
    cacheLocal(email, props);

    // Klaviyo is the second stage of validation: it is the only party that can
    // say whether this address is one it will accept. Hold the success state
    // until it answers, rather than declaring victory and hoping.
    var btn = root ? root.querySelector('[data-action="join-quiz"]') : null;
    // The label is read off the button rather than repeated here, so editing
    // the copy in resultScreen cannot leave a stale string behind.
    var btnLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Reserving'; }
    if (input) input.disabled = true;
    clearEmailNote();

    submitKlaviyo(email, props, 'prelaunch_quiz').then(function (res) {
      if (res && res.ok) {
        state.joined = true;
        render();
        return;
      }
      if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
      if (input) { input.disabled = false; input.focus(); }
      showEmailError(res && res.network
        ? 'That did not go through. Try once more.'
        : 'That address was not accepted. Check it and try again.');
    });
  }

  function labelOf(step) {
    var a = state.answers[step];
    if (a == null || Array.isArray(a)) return null;
    return QUESTIONS[step].options[a];
  }
  // Multi-select answers go over as an array of the option text, in the order
  // they were picked. compact() drops it entirely when nothing was chosen.
  function labelsOf(step) {
    var a = state.answers[step];
    if (!Array.isArray(a)) return null;
    return a.map(function (i) { return QUESTIONS[step].options[i]; });
  }

  // ---------------------------------------------------------------------------
  // Attribution + environment
  // ---------------------------------------------------------------------------
  // First-touch attribution: the UTM set and referrer are read on the very
  // first page view and kept in localStorage. Somebody who arrives from a
  // story link, leaves, and comes back direct a week later still credits the
  // story. Written once and never overwritten — later visits do not clobber it.
  var ATTR_KEY = 'bylon-attribution';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  // --- Debug surface --------------------------------------------------------
  // Attribution is hard to diagnose from the outside: it is written once, on a
  // page view that has already happened by the time anything goes wrong, and
  // the payload is sent from a fetch nobody sees. window.BylonDebug exposes all
  // of it. Add ?bylon_debug=1 to any landing URL — or run BylonDebug.on() once —
  // to log the URL parameters seen, the stored record, and the exact body sent
  // to Klaviyo together with Klaviyo's reply.
  var DEBUG_KEY = 'bylon-debug';
  function debugOn() {
    var q = false;
    try { q = new URLSearchParams(window.location.search).get('bylon_debug') === '1'; } catch (e) { /* ignore */ }
    if (q) return true;
    try { return localStorage.getItem(DEBUG_KEY) === '1'; } catch (e) { return false; }
  }
  function debugLog() {
    if (!debugOn()) return;
    console.log.apply(console, ['[Bylon debug]'].concat(Array.prototype.slice.call(arguments)));
  }
  var BylonDebug = {
    // What the browser can see in the URL right now.
    urlParams: function () {
      var out = {};
      try {
        new URLSearchParams(window.location.search).forEach(function (v, k) { out[k] = v; });
      } catch (e) { /* ignore */ }
      return { href: window.location.href, search: window.location.search, params: out };
    },
    // What was captured and kept — null if this browser has never stored one.
    attribution: function () {
      try { return JSON.parse(localStorage.getItem(ATTR_KEY) || 'null'); } catch (e) { return null; }
    },
    // What contextProperties() would put on a profile submitted right now,
    // after compact() has stripped the empty ones.
    properties: function () { return compact(contextProperties()); },
    // Forget the first-touch record so the next page load captures again.
    clear: function () {
      try { localStorage.removeItem(ATTR_KEY); } catch (e) { /* ignore */ }
      return 'cleared — reload the page with UTM parameters to capture again';
    },
    on: function () { try { localStorage.setItem(DEBUG_KEY, '1'); } catch (e) { /* ignore */ } return 'debug logging on'; },
    off: function () { try { localStorage.removeItem(DEBUG_KEY); } catch (e) { /* ignore */ } return 'debug logging off'; },
    // Filled in by submitKlaviyo on every send.
    lastRequest: null,
    lastResponse: null
  };
  window.BylonDebug = BylonDebug;

  function captureAttribution() {
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null'); } catch (e) { /* ignore */ }
    if (stored && stored.captured_at) {
      // First touch wins by design. Worth saying out loud in debug: a record
      // stored on an earlier, parameter-free visit is the usual reason a fresh
      // UTM link appears to be ignored.
      debugLog('attribution already stored from ' + stored.captured_at + ' — URL parameters on this visit are ignored', stored);
      return stored;
    }

    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var get = function (k) {
      var v = params ? params.get(k) : null;
      return v ? String(v).slice(0, 200) : null;
    };

    var ref = document.referrer || '';
    var refHost = '';
    if (ref) { try { refHost = new URL(ref).hostname; } catch (e) { refHost = ''; } }
    // Same-origin referrers are internal navigation, not a source.
    if (refHost === window.location.hostname) { ref = ''; refHost = ''; }

    var rec = {
      utm_source: get('utm_source'),
      utm_medium: get('utm_medium'),
      utm_campaign: get('utm_campaign'),
      utm_content: get('utm_content'),
      utm_term: get('utm_term'),
      // Short human codes for people rather than platforms: ?ref=nadia
      referral_code: get('ref') || get('referral') || get('via'),
      referrer_url: ref || null,
      referrer_domain: refHost || null,
      landing_path: window.location.pathname || null,
      captured_at: new Date().toISOString()
    };
    try { localStorage.setItem(ATTR_KEY, JSON.stringify(rec)); } catch (e) { /* ignore */ }
    debugLog('attribution captured from', window.location.search || '(no query string)', rec);
    return rec;
  }

  // Coarse browser name only. The full user-agent string is long, brittle, and
  // reads as fingerprinting in a profile; the name is what segments are ever
  // built on.
  function browserName() {
    var ua = navigator.userAgent || '';
    if (/Edg\//.test(ua)) return 'Edge';
    if (/OPR\/|Opera/.test(ua)) return 'Opera';
    if (/Chrome\//.test(ua) && !/Chromium/.test(ua)) return 'Chrome';
    if (/Firefox\//.test(ua)) return 'Firefox';
    if (/Safari\//.test(ua)) return 'Safari';
    return 'Other';
  }
  function deviceType() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet/i.test(ua)) return 'Tablet';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'Mobile';
    return 'Desktop';
  }
  function timezoneName() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; }
  }

  // Everything that is true of the visitor rather than of their answers.
  // Shared by the quiz submission and the landing newsletter form so both
  // produce the same shape of profile.
  //
  // The five UTM values keep their raw parameter names rather than prettier
  // labels: that is the spelling Klaviyo's own flows, Shopify, and any ad
  // reporting downstream already expect, so nothing has to be re-mapped.
  function contextProperties() {
    var a = captureAttribution();
    return {
      utm_source: a.utm_source,
      utm_medium: a.utm_medium,
      utm_campaign: a.utm_campaign,
      utm_content: a.utm_content,
      utm_term: a.utm_term,
      'Referral Code': a.referral_code,
      'Referrer': a.referrer_url,
      'Referrer Domain': a.referrer_domain,
      'First Page': a.landing_path,
      'First Seen At': a.captured_at,
      'Browser': browserName(),
      'Device': deviceType(),
      'Locale': navigator.language || null,
      'Timezone': timezoneName(),
      'Screen Width': window.screen ? window.screen.width : null
    };
  }

  // Strip nulls so a profile never grows a property with no value in it —
  // an empty property is indistinguishable from a real one in a segment.
  function compact(obj) {
    var out = {};
    Object.keys(obj).forEach(function (k) {
      var v = obj[k];
      if (v === null || v === undefined || v === '') return;
      if (Array.isArray(v) && !v.length) return;
      out[k] = v;
    });
    return out;
  }

  // ---------------------------------------------------------------------------
  // Klaviyo + local cache
  // ---------------------------------------------------------------------------
  function cacheLocal(email, props) {
    try {
      localStorage.setItem('bylon-quiz-submission', JSON.stringify({
        email: email, answers: state.answers, properties: props, submittedAt: new Date().toISOString()
      }));
    } catch (e) { /* ignore */ }
  }

  // Klaviyo groups its list-growth reporting by custom_source, so the campaign
  // is folded into that string as well as into the profile properties. That
  // makes the built-in report split by ad campaign with no segment work.
  // Falls back to the bare base string for direct and organic arrivals.
  function customSourceLabel() {
    var cfg = window.BylonKlaviyo || {};
    var base = cfg.customSource || 'Prelaunch Landing';
    var a = captureAttribution();
    var parts = [a.utm_source, a.utm_campaign].filter(Boolean);
    return parts.length ? base + ' — ' + parts.join('/') : base;
  }

  function submitKlaviyo(email, props, source) {
    var cfg = window.BylonKlaviyo || {};
    var properties = Object.assign({
      'Signup Source': source,
      'Signup At': new Date().toISOString()
    }, props);

    // Timezone is a first-class profile field rather than a custom property,
    // so Klaviyo can use it for send-time optimisation. City/region/country
    // are deliberately not sent: they would need an IP lookup from a third
    // party. Klaviyo fills them in from the visitor's IP once the onsite
    // script (klaviyo.js) is on the page.
    var profileAttributes = { email: email, properties: properties };
    var tz = timezoneName();
    if (tz) profileAttributes.location = { timezone: tz };

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSourceLabel(),
          profile: { data: { type: 'profile', attributes: profileAttributes } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    // Kept whether or not the send succeeds, so the payload can be read back
    // from the console after the fact: BylonDebug.lastRequest.
    BylonDebug.lastRequest = payload;
    debugLog('sending to Klaviyo', {
      listId: cfg.listId,
      custom_source: payload.data.attributes.custom_source,
      utm_source: properties.utm_source || '(none)',
      properties: properties
    });

    if (!cfg.publicKey || !cfg.listId) {
      console.warn('[Bylon] Klaviyo not configured (publicKey/listId missing). Captured locally only:', { email: email, custom_source: customSourceLabel(), attributes: profileAttributes });
      // Nothing to validate against, so the form behaves as it did before the
      // keys were set: success, and the payload in the console.
      return Promise.resolve({ ok: true, skipped: true });
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      BylonDebug.lastResponse = { status: res.status, ok: res.ok };
      if (res.ok) {
        debugLog('Klaviyo accepted the signup (HTTP ' + res.status + ')');
        return { ok: true, status: res.status };
      }
      // Klaviyo answers a rejection with a JSON:API errors array naming the
      // offending field. The status alone is not actionable, so read the body
      // before reporting — a silent 4xx here looks identical to a success.
      return res.text().then(function (body) {
        var detail = body;
        try {
          var parsed = JSON.parse(body);
          if (parsed && parsed.errors) {
            detail = parsed.errors.map(function (e) {
              return [e.title, e.detail, e.source && e.source.pointer].filter(Boolean).join(' | ');
            }).join('\n');
          }
        } catch (e) { /* not JSON — show it raw */ }
        BylonDebug.lastResponse = { status: res.status, ok: false, body: body };
        console.error('[Bylon] Klaviyo rejected the signup (HTTP ' + res.status + '):\n' + detail, { sentPayload: payload });
        return { ok: false, status: res.status, detail: detail };
      });
    }).catch(function (err) {
      BylonDebug.lastResponse = { error: String(err) };
      console.error('[Bylon] Klaviyo request failed (network/CORS)', err);
      // A blocked or offline request is not the visitor's mistake, so it is
      // reported differently from a rejected address.
      return { ok: false, network: true, detail: String(err) };
    });
  }

  // ---------------------------------------------------------------------------
  // Global wiring (triggers, anchors, landing form)
  // ---------------------------------------------------------------------------
  if (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (btn && root.contains(btn)) {
        var action = btn.getAttribute('data-action');
        if (action === 'back') return back();
        if (action === 'close') return closeQuiz();
        if (action === 'select') return selectOpt(parseInt(btn.getAttribute('data-opt'), 10));
        if (action === 'begin') return beginQuiz();
        if (action === 'advance') return advance();
        if (action === 'choose-plant') return choosePlant(btn.getAttribute('data-plant'), btn);
//         if (action === 'pick-price') {
//           return pickPrice(btn.getAttribute('data-plant'),
//             parseInt(btn.getAttribute('data-index'), 10),
//             parseInt(btn.getAttribute('data-size'), 10), btn);
//         }
        if (action === 'join-quiz') return joinFromQuiz();
        if (action === 'fix-email') return applyEmailSuggestion(btn.getAttribute('data-email'));
      }
      // click on the dimmed backdrop (outside the panel) closes
      if (e.target.classList && e.target.classList.contains('bylon-quiz')) closeQuiz();
    });

    // Email field: checked as it is typed, once the address is far enough
    // along to judge, and again on leaving the field. Both write to the note
    // node directly — see checkEmailField.
    root.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'bqz-email') scheduleEmailCheck();
    });
    // focusout rather than blur: blur does not bubble, so delegation misses it.
    root.addEventListener('focusout', function (e) {
      if (e.target && e.target.id === 'bqz-email') {
        clearTimeout(emailTimer);
        // Leaving an empty field is not a mistake yet, so it stays quiet.
        if (e.target.value.trim()) checkEmailField(false);
      }
    });
    // Return submits from the field — the input is not inside a <form>, so
    // nothing does this on its own.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target || e.target.id !== 'bqz-email') return;
      e.preventDefault();
      joinFromQuiz();
    });

    // Nothing here for the result cards: every control on them is a real
    // <button>, so Enter and Space are the browser's own to handle.
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) closeQuiz();
  });

  // Open quiz from any #quiz link; smooth-scroll #collectors links.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href === '#quiz' || href.slice(-6) === '#quiz') {
      e.preventDefault(); openQuiz();
    } else if (href === '#collectors' || href.slice(-11) === '#collectors') {
      var target = document.getElementById('collectors') || document.querySelector('.newsletter');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  // Progressive enhancement: reroute the landing newsletter form to Klaviyo.
  function enhanceLandingForm() {
    var scope = document.querySelector('.newsletter');
    if (!scope) return;
    var form = scope.querySelector('form');
    if (!form || form.dataset.bylonEnhanced) return;
    form.dataset.bylonEnhanced = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var field = form.querySelector('input[type="email"], input[name="contact[email]"]');
      var email = field ? field.value.trim() : '';
      // Same shape check as the quiz form. The landing form has no note node
      // of its own, so the browser's own validation message carries it.
      var shapeError = emailShapeError(email);
      if (shapeError) {
        if (field) {
          field.setCustomValidity(shapeError);
          field.reportValidity();
          field.addEventListener('input', function clear() {
            field.setCustomValidity('');
            field.removeEventListener('input', clear);
          });
        }
        return;
      }
      var props = compact(Object.assign({ 'Signup Form': 'Collectors Landing' }, contextProperties()));
      cacheLocal(email, props);
      submitKlaviyo(email, props, 'prelaunch_landing');
      var wrap = form.parentNode;
      var done = document.createElement('p');
      done.className = 'bylon-collectors__joined';
      done.textContent = JOINED_MSG;
      wrap.replaceChild(done, form);
    });
  }

  // Klaviyo onsite tracking (klaviyo.js). This is what gives a profile its
  // IP-derived location and its First/Last Active timestamps — none of which
  // the subscription API sets on its own.
  //
  // The Klaviyo Shopify app installs this on the storefront, but the password
  // page renders through layout/password.liquid and may not receive the app's
  // embed, which is why pre-launch profiles arrive with no location. Loading
  // it here covers that gap without a second place to configure the key. The
  // guards below make it a no-op wherever the app has already done the job.
  function ensureKlaviyoOnsite() {
    var cfg = window.BylonKlaviyo || {};
    if (!cfg.publicKey) return;
    if (window.klaviyo || window._learnq) return;
    if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]')) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(cfg.publicKey);
    document.head.appendChild(s);
  }

  // Head start: the question images begin downloading while the visitor is
  // still on the landing page, so by the time the quiz is opened they are
  // already in cache and the loader is only holding its minimum. Deferred to
  // idle time so it never competes with the landing page's own rendering.
  function warmImages() {
    var start = function () {
      preload(gateUrls()).then(function () { preload(restUrls()); });
    };
    if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 4000 });
    else setTimeout(start, 1500);
  }

  function init() {
    // The single most useful line when attribution is in question: what the
    // page was actually loaded with. If the UTM parameters are missing here,
    // nothing downstream can recover them.
    debugLog('landing URL', window.location.href);
    // Must run on the landing view itself: the UTM parameters are gone from
    // the URL by the time anyone reaches a form on a later page.
    captureAttribution();
    ensureKlaviyoOnsite();
    enhanceLandingForm();
    render();
    warmImages();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
